export default __webpack_public_path__ + "static/iba-logo-small-43b9ce9eea7cc1617b17e4b2677db459.png";